export const TrackingAction = {
    SUBMIT: "submit",
    SUBMIT_OK: "submit-ok",
    SUBMIT_CLIENT_ERROR: "submit-client-error",
    SUBMIT_SERVER_ERROR: "submit-server-error",
    VALUE_OK: "value-ok",
    VALUE_ERROR: "value-error",
    OPEN: "open",
    CLOSE: "close",
    SHOW: "show",
    CLICK: "click",
    SCROLL: "scroll",
    EXPAND: "expand",
    ENRICHED: "enriched",
    SYSTEM_ASSIGNED: "system assigned",
    REMOVE: "remove",
} as const;
